module.exports = __webpack_public_path__ + "static/media/product-page.99b95d17.jpg";